import React, { useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import block from 'bem-cn';
import SVGInline from 'react-svg-inline';

import { actions } from 'features/Game';
import { getModelByGameSettings, stepsCount, getWinnings } from 'features/Game/data';
import lightPng from './img/light.png';
import gardSvg from './img/gard.svg';
import bottomGardSvg from './img/bottom-gards.svg';
import { playersSvgs } from './img';
import playerSvg from './img/player.svg'
import { roundingFunc } from 'services/helpers/roundingFunc';

import './GameView.scss';

const b = block('game-view');

const GameView = () => {
  const dispatch = useDispatch();
  const { linesCount, playersCount, amount, isAutoPick, autoPickData } = useSelector(state => state.game.gameSettings);
  const temp_pick = useSelector(state => state.game.temp_pick);
  const wrong_picks = useSelector(state => state.game.wrong_picks);
  const rtp = useSelector(state => state.game.rtp);
  const coeffs = useSelector(state => state.game.coeffs);
  const lives = useSelector(state => state.game.lives);
  const gameStatus = useSelector(state => state.game.gameStatus);
  const result = useSelector(state => state.game.result);
  const currency = useSelector(state => state.auth.currency);

  const isPlaced = useMemo(() => gameStatus === 1, [gameStatus]);
  
  const isLost = (result !== null) && (gameStatus === 0);

  const pick = useCallback(pickInfo => {
    if (pickInfo.stepId === temp_pick.length) {
      dispatch(actions.pick(pickInfo))
    }
  }, [dispatch, temp_pick])

  const autoPickClick = useCallback(pickInfo => {
    let resultString = autoPickData;
    if (pickInfo.stepId === autoPickData.length) {
      resultString = resultString + pickInfo.glassId.toString();
    } else if (pickInfo.stepId <= autoPickData.length) {
      if (pickInfo.stepId === autoPickData.length - 1 && pickInfo.glassId.toString() === autoPickData[pickInfo.stepId]) {
        resultString = autoPickData.substring(0, autoPickData.length - 1)
      } else resultString = autoPickData.split('').map((t, i) => i === pickInfo.stepId ? pickInfo.glassId.toString() : t).join('');
    }
    dispatch(actions.setGameSettings({ autoPickData: resultString }))
  }, [autoPickData, dispatch])

  const click = useMemo(() => {
    if (gameStatus === 1) {
      return pick;
    } else {
      if (isAutoPick) {
        return autoPickClick;
      } else {
        return f => f;
      }
    }
  }, [autoPickClick, gameStatus, isAutoPick, pick])

  const tabs = useMemo(() => 
  getModelByGameSettings(linesCount).map((tempStep, index) =>
  <div
    className={b('step', { isActive: (index === temp_pick.length && isPlaced) || (index === autoPickData.length && !isPlaced && isAutoPick) })}
    key={index}>
    {tempStep?.map(tempGlass => {
      const isWrong = wrong_picks.find(t => t.stepId === tempGlass.stepId && t.glassId === tempGlass.glassId) !== undefined;
      const isEmptyWrong = isLost && tempGlass.glassId !== +result[index] && !isWrong;
      const isAutoPickLighting = isAutoPick && +autoPickData[tempGlass.stepId] === tempGlass.glassId;
      return <div
        className={b('glass', {
          isWrong,
          isEmptyWrong,
          isAutoPickLighting,
        })}
        key={tempGlass.glassId}
        onClick={() => click(tempGlass)}>
          {(tempGlass.glassId === +temp_pick[tempGlass.stepId]) && (tempGlass.stepId >= temp_pick.length - lives) && temp_pick.length !== stepsCount ?
          <SVGInline svg={playersSvgs[(temp_pick.length - tempGlass.stepId - 1 + (playersCount - lives)).toString()] || playerSvg} className={b('player').toString()} /> : null}
      </div>
    })}
  </div>), [linesCount, temp_pick, isPlaced, autoPickData, isAutoPick, wrong_picks, isLost, result, lives, playersCount, click])

  const startPlayers = useMemo(() => {
    let resultPlayers = []
    for (let i = 0; i < (lives - temp_pick.length); i ++) {
      resultPlayers = [...resultPlayers, <SVGInline key={i} svg={playersSvgs[(i + temp_pick.length).toString()] || playerSvg} className={b('start-player').toString()} />]
    }
    return resultPlayers;
  }, [lives, temp_pick.length])

  const endPlayers = useMemo(() => {
    let resultPlayers = []
    for (let i = 0; i < (lives); i ++) {
      resultPlayers = [...resultPlayers, <SVGInline key={i} svg={playersSvgs[i.toString()] || playerSvg} className={b('start-player').toString()} />]
    }
    return temp_pick.length === stepsCount ? <div className={b('end-players')}>{resultPlayers}</div> : null;
  }, [lives, temp_pick.length])

  const winnings = useMemo(() => getWinnings(linesCount, playersCount, rtp, amount, coeffs)
    .map((t, index) => <div className={b('winning', { isActive: index === temp_pick.length - 1 })} key={index}>
      {`${roundingFunc(+t)} ${currency}`}
    </div>)
  , [amount, coeffs, currency, linesCount, playersCount, rtp, temp_pick.length])

  return <article className={b()}>
    <img className={b('light', { position: 'top' })} src={lightPng} alt="" />
    <img className={b('light', { position: 'bottom' })} src={lightPng} alt="" />

    <div className={b('circle')} />
    <div className={b('content')}>
      <div className={b('platform')}>
        {endPlayers}
        <SVGInline svg={gardSvg} className={b('top-gards').toString()} />
      </div>
      <div className={b('glass-block')}>
        {tabs}
      </div>
      <div className={b('platform')}>
        <div className={b('start-players')}>
          {startPlayers}
        </div>
        <SVGInline svg={bottomGardSvg} className={b('bottom-gards').toString()} />
      </div>
    </div>
    <div className={b('winnings')}>
      {winnings}
    </div>
  </article>
}

export default GameView;